const forms = {
  state: {
    relpsRemote: null,
    relpsRemoteAppended: null,
    relationshipRegister: null,
    relationshipRegisterCounter: null
  },
  mutations: {
    changeRelpsRemote(state, payload) {
      state.relpsRemote = payload;
    },
    changeRelpsRemoteAppended(state, payload) {
      state.relpsRemoteAppended = payload;
    },
    changeRelationshipRegister(state, payload) {
      state.relationshipRegister = payload;
    },
    changeRelationshipRegisterCounter(state, payload) {
      state.relationshipRegisterCounter = payload;
    }
  },
  actions: {
    changeRelpsRemote({ commit }, payload) {
      commit("changeRelpsRemote", payload);
    },
    changeRelpsRemoteAppended({ commit }, payload) {
      commit("changeRelpsRemoteAppended", payload);
    },
    changeRelationshipRegister({ commit }, payload) {
      commit("changeRelationshipRegister", payload);
    },
    changeRelationshipRegisterCounter({ commit }, payload) {
      commit("changeRelationshipRegisterCounter", payload);
    }
  },
  getters: {
    getRelpsRemote: state => {
      return state.relpsRemote;
    },
    getRelpsRemoteAppended: state => {
      return state.relpsRemoteAppended;
    },
    getRelationshipRegister: state => {
      return state.relationshipRegister;
    },
    getRelationshipRegisterCounter: state => {
      return state.relationshipRegisterCounter;
    }
  }
};
// eslint-disable-next-line
export default forms;
